/**
 * Centralized source of truth for localStorage keys used throughout the application.
 * This ensures consistency and prevents typos when accessing localStorage.
 */
export const LOCAL_STORAGE_KEYS = {
  // Zustand persist stores (prefixed with 'ls-' for local storage)
  AUTH: 'ls-auth',
  THEME: 'ls-theme',
  REMEMBER_ME: 'ls-remember-me',
  SANDBOX: 'ls-sandbox',
  CONTEXT: 'ls-context',
  LANGUAGE: 'ls-language',
  WHITE_LABEL: 'ls-white-label',
  DASHBOARD_LAYOUT: 'ls-dashboard-layout',
  SIDEBAR: 'ls-sidebar',
  REPORT_AUTO_REFRESH: 'ls-report-auto-refresh',
} as const

/**
 * Centralized source of truth for sessionStorage keys used throughout the application.
 * These are cleared when the browser tab/window is closed.
 */
export const SESSION_STORAGE_KEYS = {
  // Zustand persist stores (prefixed with 'ss-' for session storage)
  MANAGED_ACCOUNT: 'ss-managed-account',
  ENVELOPE_ACCESS: 'ss-envelope-access',
  LOGIN_RETURN_ENVELOPE: 'ss-login-return-envelope',
  LOGIN_RETURN_PATH: 'ss-login-return-path',
  MICROSOFT_SIGN_IN: 'ss-microsoft-sign-in',
} as const

// Type helper to ensure type safety when accessing localStorage
export type LocalStorageKey =
  (typeof LOCAL_STORAGE_KEYS)[keyof typeof LOCAL_STORAGE_KEYS]

// Type helper to ensure type safety when accessing sessionStorage
export type SessionStorageKey =
  (typeof SESSION_STORAGE_KEYS)[keyof typeof SESSION_STORAGE_KEYS]
